var _a, _b;
import { immerable } from 'immer';
/**
 * 単一選択
 */
var SingleSelectedNote = /** @class */ (function () {
    function SingleSelectedNote() {
        this[_a] = true;
        this.isMultipuleSelection = false;
    }
    Object.defineProperty(SingleSelectedNote.prototype, "notes", {
        get: function () {
            return this.selectedNote ? [this.selectedNote] : [];
        },
        enumerable: false,
        configurable: true
    });
    SingleSelectedNote.prototype.initialize = function (notes) {
        this.selectedNote = notes.length > 0 ? notes[0] : undefined;
    };
    SingleSelectedNote.prototype.unselect = function () {
        this.selectedNote = undefined;
    };
    SingleSelectedNote.prototype.select = function (note) {
        this.selectedNote = note;
    };
    SingleSelectedNote.prototype.clear = function () {
        this.selectedNote = undefined;
    };
    return SingleSelectedNote;
}());
_a = immerable;
/**
 * 複数選択
 */
var MultiSelectedNote = /** @class */ (function () {
    function MultiSelectedNote() {
        this[_b] = true;
        this.selectedNotes = [];
        this.isMultipuleSelection = true;
    }
    Object.defineProperty(MultiSelectedNote.prototype, "notes", {
        get: function () {
            return this.selectedNotes;
        },
        enumerable: false,
        configurable: true
    });
    MultiSelectedNote.prototype.initialize = function (notes) {
        this.selectedNotes = notes;
    };
    MultiSelectedNote.prototype.unselect = function (note) {
        var index = this.selectedNotes.findIndex(function (selectedNote) { return selectedNote.id === note.id; });
        if (index !== -1) {
            this.selectedNotes.splice(index, 1);
        }
    };
    MultiSelectedNote.prototype.select = function (note) {
        this.selectedNotes.push(note);
    };
    MultiSelectedNote.prototype.clear = function () {
        this.selectedNotes = [];
    };
    return MultiSelectedNote;
}());
_b = immerable;
/**
 * 選択されたノートのインスタンスを生成
 */
export function createSelectedNotes(selectionMode) {
    return isMultipuleSelection(selectionMode) ? new MultiSelectedNote() : new SingleSelectedNote();
}
/**
 * 複数選択であるか
 */
export function isMultipuleSelection(selectionMode) {
    return selectionMode === 'multipule';
}
